import * as React from 'react';
import MaterialTable from 'material-table';
import convertFirestoreDate from '../../utils/convertFirestoreDate';
import SalesCenterSetup from './setup/salesCenterSetup';
import SalesCenterDetailsPane from './detailsPane/salesCenterDetailsPane';

const DetailPanel = ({ rowData, salesCenterList, getLatestSalesCenter }) => {
  const [, forceUpdate] = React.useState(0);
  const latestData = getLatestSalesCenter(rowData.builderId) || rowData;

  React.useEffect(() => {
    const interval = setInterval(() => {
      const current = getLatestSalesCenter(rowData.builderId);
      if (current && current !== latestData) {
        forceUpdate((n) => n + 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData.builderId, getLatestSalesCenter]);

  return (
    <div style={{ width: '100%', backgroundColor: 'aliceblue', padding: '10px' }}>
      {
        latestData.status === 'COMPLETE'
          ? <SalesCenterDetailsPane salesCenter={latestData} salesCenterList={salesCenterList} />
          : <SalesCenterSetup salesCenter={latestData} />
      }
    </div>
  );
};

const BuilderSummaryTable = (props) => {
  return (
    <div style={{ padding: 10, margin: 'auto', maxWidth: '100%' }}>
      <MaterialTable
        columns={
          [
            { title: 'Company Name', field: 'companyName' },
            { title: 'Sales Center Name', field: 'salescenterName' },
            { title: 'Builder ID', field: 'builderId' },
            {
              title: 'Branch',
              field: 'jenkinsBuild.branchName',
              render: (rowData) => rowData.jenkinsBuild?.branchName || '',
            },
            {
              title: 'Last Deployed',
              field: 'jenkinsBuild.date',
              render: (rowData) => {
                const date = rowData.jenkinsBuild?.date;
                return date ? convertFirestoreDate(date) : '';
              },
            },
            {
              title: 'Date Created',
              field: 'dateCreated',
              render: (rowData) => {
                const date = rowData.dateCreated;
                return date ? convertFirestoreDate(date) : '';
              },
            },
          ]
        }
        // eslint-disable-next-line react/destructuring-assignment
        data={props.salesCenterList}
        actions={
          [
            {
              icon: 'launch',
              tooltip: 'Launch Web Site',
              onClick: (event, rowData) => window.open(rowData.websiteUrl, '_blank'),
            },
          ]
        }
        title="Summary of Builders"
        detailPanel={
          // eslint-disable-next-line react/no-unstable-nested-components
          (rowData) => (
            <DetailPanel
              rowData={rowData}
              // eslint-disable-next-line react/destructuring-assignment
              salesCenterList={props.salesCenterList}
              // eslint-disable-next-line react/destructuring-assignment
              getLatestSalesCenter={props.getLatestSalesCenter}
            />
          )
        }
        options={
          {
            sorting: true,
            pageSize: 25,
            actionsColumnIndex: -1,
            rowStyle: (rowData) => ({
              backgroundColor: (rowData.status === 'SETUP') ? 'lightgreen' : '#FFFFFF',
            }),
          }
        }
        onRowClick={(event, rowData, togglePanel) => togglePanel()}
      />
    </div>
  );
};

export default BuilderSummaryTable;
